import script from "./Step4Content.vue?vue&type=script&setup=true&lang=js"
export * from "./Step4Content.vue?vue&type=script&setup=true&lang=js"

import "./Step4Content.vue?vue&type=style&index=0&id=cb713b84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb713b84"]])

export default __exports__